import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import chevronLeftIcon from '../../assets/icons/chevron_left.svg?raw&inline';

import { KybDescription } from './KybDescription'; 

import type { Contact, ListType } from '../../types';
import { CompanyRoleCard } from './CompanyRoleCard';

export const CompanyMembersList: React.FC<CompanyMembersListProps> = ({ 
  privacyPolicyAccepted,
  // TODO hardcoded internally until we refactor CompanyMembers since have a miniwizard
  // currentStep,
  membersData,
  organization,
  isBeneficiary,
  checkNextStep,
  handleSumBeneficiaries,
  onDeleteBeneficiary,
  onModalOpen,
  onNextStepClick,
  onPreviousStepClick,
}) => {
  const { t } = useTranslation();
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');

  const handleEntityName = () => {
    if (organization)
      return organization.nombre.length > 30 ? organization.nombre.slice(0, 30) + '...' : organization.nombre;
  };

  useEffect(() => {
    if (isBeneficiary) {
      setTitle(t('kyb_flow.beneficiaries.title'));
      setDescription(t('kyb_flow.beneficiaries.description'));
      return
    }
    setTitle(t('kyb_flow.org_members_card.title'));
    setDescription(t('kyb_flow.org_members_card.description'));
  }, [isBeneficiary, t]);

  // hay 3 estado de texto si no es beneficiario, es beneficiario y privay accepted o ninguna de esa (el primer estado)
  let nextStepButtonText = isBeneficiary ? t('kyb_flow.steps.step_3_button') : t('kyb_flow.steps.step_2_button');
  if (isBeneficiary && privacyPolicyAccepted) {
    nextStepButtonText = t('kyb_flow.steps.step_3_button_beneficiary');
  }

  return (
    <div className="row d-flex mt-5 justify-content-center position-relative" style={{ maxWidth: 1000 }}>
      <div className="w-100 text-center mb-5">
        {isBeneficiary && 
        <span 
          className="font-weight-400 size-12 cursor-pointer position-absolute d-flex align-items-center" 
          onClick={onPreviousStepClick}
          style={{top: 5, left: 0}}
        >
          <span 
            className="d-flex align-items-center" 
            dangerouslySetInnerHTML={{ __html: chevronLeftIcon }} 
          />
          {t('kyb_flow.beneficiaries.back')}
        </span>}

        <div className="badge rounded-pill text-uppercase size-12 font-weight-600 w-auto bg-kyb-pill text-dark">
          {handleEntityName()}
        </div>
      </div>

      <span className="size-10 font-weight-600 hyperlink">
        {/* TODO hardcoded until we refactor CompanyMembers since have a miniwizard */}
        {t('kyb_flow.steps_count', { step: isBeneficiary ? 2 : 1, total: 4 })}
      </span>

      <KybDescription
        title={title}
        description={description}
      />

      <div className="col d-flex flex-column align-items-center">
        <div className="d-flex flex-wrap w-100">
          {membersData.map((role: Contact, index: number) => (
            <CompanyRoleCard
              key={index}
              index={index}
              member={role}
              isBeneficiaryCard={isBeneficiary || false}
              onModalOpen={(index, list) => onModalOpen(index, list || 'rolesData')}
              onDeleteClick={() => onDeleteBeneficiary(index)}
            />
          ))}
          {isBeneficiary && (
          <>
            <div className={`col-12 col-md-6 px-0 ${(membersData.length % 2) === 0 ? 'ps-md-0 pe-md-2' : 'ps-md-2 pe-md-0'}`}>
            <button
              className={`btn btn-gray-1000 px-4 py-3 my-2 w-100 text-start font-weight-600`}
              onClick={() => onModalOpen(-1, 'beneficiariesData')}
              disabled={handleSumBeneficiaries() >= 100}
              >
              {t('kyb_flow.beneficiaries.add')}
            </button>
            <span className="disable-select" style={{opacity: 0}}>&#8192&#8192&#8192&#8192&#8192&#8192&#8192&#8192&#8192&#8192&#8192</span>
            </div>
            {membersData.length < 1 && <div className="col-12 col-md-6 px-0 ps-md-2 pe-md-0 disable-select" style={{opacity: 0}}>
              &#8192&#8192&#8192&#8192&#8192&#8192&#8192&#8192&#8192&#8192&#8192&#8192
            </div>}
            <div className="d-flex justify-content-start w-100 flex-column">
              <span className="size-14 text-dark">
                {t('kyb_flow.beneficiaries.share')}
                <span className={handleSumBeneficiaries() > 100 ? 'text-danger' : ''}> {handleSumBeneficiaries()}%</span> /
                100%
              </span>
              {handleSumBeneficiaries() > 100 && <span className="text-danger size-14">
                {t('kyb_flow.beneficiaries.stake_error')}
              </span>}
            </div>
          </>)}
        </div>
        <button
          className="btn btn-black w-100 w-md-50 mt-3"
          onClick={onNextStepClick}
          disabled={checkNextStep()}
        >
          {nextStepButtonText}
        </button>
      </div>
    </div>
  );
};

interface CompanyMembersListProps {
  /** 
   * solo se usa para condicionar el texto del boton siguiente
   * va ligado a isBeneficiary y solo es necesitado 
   * para el step 2 de CompanyMembers por q es el miniwizard accionista
   * TODO al refactor quitando miniwizard (flat 1 solo wizard) esto puede q no
   * sea necesario
   * */
  privacyPolicyAccepted?: boolean;
  currentStep: number;
  membersData: any;
  organization: any;
  isBeneficiary?: boolean;
  checkNextStep: () => boolean;
  handleSumBeneficiaries: () => number;
  onDeleteBeneficiary: (index: number) => void;
  onModalOpen: (index: number, list: ListType) => void; 
  onNextStepClick: () => void;
  onPreviousStepClick: () => void;
}